import React from "react";
import Grid from "@mui/material/Grid";

export default function InvestmentCapitalContainer() {
  return (
    <Grid container spacing={2}>
      {/* {alreadyDismissed && ( */}
      <Grid item xs={12}></Grid>
      {/* )} */}
      <Grid item xs={12}></Grid>
    </Grid>
  );
}
